import React from 'react';
import {
    Linking,
    TouchableOpacity,
    View
} from 'react-native';

import {styles} from "./InvestFlowConsentsViewStyle";
import InvestFlowRadioButtonView from "../investflowradiobutton/InvestFlowRadioButtonView";
import {LanguageManager, Managers} from "@levelapp/softfabric";
import App from "../../../../../App";
import {TranslationView} from "@levelapp/softfabric-ui";

interface InvestFlowConsentsViewProps {
    acceptTermsOfUse: boolean;
    setAcceptTermsOfUse: (value: boolean) => void;
    acceptDefinitiveSubscription: boolean;
    setAcceptDefinitiveSubscription: (value: boolean) => void;
}

export const InvestFlowConsentsView = ({acceptTermsOfUse, setAcceptTermsOfUse, acceptDefinitiveSubscription, setAcceptDefinitiveSubscription}: InvestFlowConsentsViewProps) => {

    const languageManager: LanguageManager = App.current.resolve<LanguageManager>(Managers.LANGUAGE_MANAGER);

    const termsOfUseBaseUrl: string = "https://www.beebonds.com/wp-content/uploads/2024/02";

    const termsOfUseLanguageMap = {
        "fr-BE": `${termsOfUseBaseUrl}/BeeBonds-Conditions-generales-24-02-02-.pdf`,
        "nl-BE": `${termsOfUseBaseUrl}/Algemene-Gebruiksvoorwaarden-BeeBonds-02.2024.pdf`,
        "en-GB": `${termsOfUseBaseUrl}/BeeBonds-Terms-and-Conditions-EN-2024-02-02.pdf`
    };

    function onLinkPress() {
        // @ts-ignore
        Linking.openURL(termsOfUseLanguageMap[languageManager.language]);
    }

    return (
        <View style={[styles.page]}>
            <InvestFlowRadioButtonView radioState={acceptTermsOfUse} setRadioState={setAcceptTermsOfUse}>
                <View style={{flexDirection: 'row'}}>
                    <TranslationView style={[styles.text]}>investflow.consents.accept.terms.of.use</TranslationView>
                    <TouchableOpacity onPress={onLinkPress}>
                        <TranslationView style={[styles.linkText]}>investflow.consents.terms.of.use</TranslationView>
                    </TouchableOpacity>
                </View>
            </InvestFlowRadioButtonView>
            <InvestFlowRadioButtonView radioState={acceptDefinitiveSubscription} setRadioState={setAcceptDefinitiveSubscription}>
                <TranslationView style={[styles.text]}>investflow.consents.accept.definitive.subscription</TranslationView>
            </InvestFlowRadioButtonView>
        </View>
    );
}

export default InvestFlowConsentsView;